import script from "./SqwervFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./SqwervFooter.vue?vue&type=script&setup=true&lang=js"

import "./SqwervFooter.vue?vue&type=style&index=0&id=caa66640&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caa66640"]])

export default __exports__